module.exports = __webpack_public_path__ + "static/exo-v6-latin-regular-647101d8f43d19c56726de30a208f0c1.eot";